angular.module('property-deal')
    .component('propertyDealFileAttachmentButton', {
        bindings: {
            propertyDealId: '<',
            attachment: '<',
            stage: '<'
        },
        templateUrl: 'app/property-deal/file-attach-button.html',
        controller: function (PropertyDealService) {
            this.PropertyDealService = PropertyDealService
        }
    })
